      
// Modal : Search
const modalSearchElement = document.getElementById('modal-search');
const modalSearch = new A11yDialog(modalSearchElement);		 

// Modal : Minicart
const modalCartElement = document.getElementById('modal-minicart');
const modalCart = new A11yDialog(modalCartElement);		 
      

jQuery( document ).ready( function( $ ) {

	var $body = $('body');
	var $window = $(window),
		windowScrollTop = 0,
		windowHeight = $window.height();

	// Lazy Load
	var lazyLoadImages = new LazyLoad({
	    elements_selector: ".lazyload",   
	});
		
	function init_general() {

        // Sitenotice
        var siteNoticeShown = localStorage.getItem('baea_site_notice');
		var mobileBreakpoint = 840;
      
        if (!siteNoticeShown && $('.header-notice').length > 0) {
            $('.header-notice').addClass('is-visible');
            $body.addClass('has-header-notice');
            $('.button-close-header-notice').on('click', function(e) {
                e.preventDefault();
                $body.removeClass('has-header-notice');
                $('.header-notice').removeClass('is-visible');
                localStorage.setItem('baea_site_notice', true);
            });
        }      
      
      	// Mobile : Submenu
      	$('.submenu-title > a').on('click', function(e) {
          	if ($(window).width() <= mobileBreakpoint && $(this).parent().find('.sub-submenu').length > 0) {
          		e.preventDefault();
              	$(this).parent().find('.sub-submenu').addClass('is-visible');
            }
        });
      
      	// Mobile : Menu
      	$('.button-menu').on('click', function(e) {
       		// Hide currencies, if open
          	$body.removeClass('show-currencies');
        });
      
      	// Mobile : Submenu : Back
      	$('.submenu-back').on('click', function(e) {
      		$(this).parent().removeClass('is-visible');
        });
      
      	// Mobile : Currencies
		$('.menu-item-currencies').on('click', function(e) {
          	if ($(window).width() <= mobileBreakpoint ) {
          		$body.toggleClass('show-currencies').removeClass('show-menu');
            }      
        });

      	// Toggle Class
		$body.on('click','div[data-toggle], button[data-toggle], a[data-toggle]', function(e){
			e.preventDefault();
			$body.toggleClass($(this).data('toggle'));
		});	 

      	// Minicart, disable click for JS users
      	$('.menu-item-bag > a').on('click', function(e) {
      		e.preventDefault();
        });
      
      	// Minicart, bind quantity change to cart.js
      	$('.minicart-quantity input').on('change', function(e) {
      		CartJS.updateItemById($(this).data('id'), $(this).val());
        });

      	// Minicart, hide / show if empty
       	$(document).on('cart.requestComplete', function(event, cart) {
          	
          	if (cart.item_count == 0) {
          		modalCart.hide();
              	$('.minicart-checkout').addClass('disabled');
            } else {
              	$('.minicart-checkout').removeClass('disabled');
            }
          	
          	if ($('.product-form.simple').length) {
            	// Show mini cart, we've just added something to the cart
            	modalCart.show();
            }
          
          	// Update Images
          	lazyLoadImages.update();
          
    	});
      
      	if ($('.minicart-item-count').text() == '0') {
      		$('.minicart-checkout').addClass('disabled');
          	$('.minicart-empty').css('display','block');
        }
      
      	modalCart.on('show', function (dialogEl, event) {
			// Update lazyloaded images
          	lazyLoadImages.update();
		});
      		
		
      	// White Header
      	if ($body.hasClass('has-white-header')) {
			
          var $hero = $('.layout-page-hero');
          var heroOffset = $hero.height() - $('.header').height();
          
          // Listen for scroll
          $window.on('scroll', function(e) {
              windowScrollTop = $window.scrollTop();
              requestAnimationFrame(updateHeader);
          });

          // Listen for resize
          $window.on('resize', function(e) {
              windowHeight = $(window).height();
              heroOffset = $hero.height()  - $('.header').height();
          });       

		  function updateHeader() {
			          
			// Fix product summary			
			if (windowScrollTop > heroOffset) {
				$body.removeClass('has-white-header');
			} else {
				$body.addClass('has-white-header');
			}		
			
		  }     
          
        }
      
      	// Cookie Banner
      	init_cookie();

        // Down Arrow
        var $down = $('.button-down');
                   
        if ($down.length > 0) {
            $down.on('click', function(e) {
            	$('html, body').animate({
    				scrollTop: $(this).parent().parent().height()
 				}, 500); 	
            });
        }
      	
      
      	// Dropdown menus
      	if (Modernizr.touchevents) {
          	
          	var $dropdowns = $('.dropdown');
          
          	$dropdowns.on('click',function(e) {
              	if ($(this).hasClass('open')) {
              		$dropdowns.removeClass('open');
                } else {
              		$dropdowns.removeClass('open');
					$(this).toggleClass('open');
              	}
            });
        }
      
      	// Theme customizer, refresh image loading on change
      	$(document).on('shopify:section:load', function(e) {
      		lazyLoadImages.update();
        });
	}

  	function init_layouts() {
  
      	// Article
      	if ($body.hasClass('template-article')) {
        	var $share = $('.button-share');
          	
          	$share.on('click', function(e) {
          		e.preventDefault();
            	$(this).parent().toggleClass('active');
          	});
          
        } else if ($body.hasClass('template-product')) {
			init_product();
        } else if ($body.hasClass('template-customers/login')) {
        	init_account();
        } else if ($body.hasClass('template-page')) {
        	init_page();
        } else if ($body.hasClass('template-customers/addresses')) {
        	init_account();
        } else if ($body.hasClass('template-cart')) {
        	init_cart();
        } else if ($body.hasClass('template-collection')) {
        	init_category();
        }
      
    }
  	
  	function init_product() {

    	var $productSummary = $('.product-summary'),
            $productSummaryInner = $('.product-summary-inner'),
			$productImages = $('.product-images'),
            productImageOffsets = [],
			productImageActive = 0,
			footerOffset = $('.layout-product').height() - windowHeight,
            productMonogram = $('#monogram');
		       
		// Load at top of the page
		window.onbeforeunload = function () {
			window.scrollTo(0, 0);
		}	
	
		// Listen for scroll
		$window.on('scroll', function(e) {
			windowScrollTop = $window.scrollTop();
		});
		
		// Listen for resize
		$window.on('resize', function(e) {
			windowHeight = $(window).height();
			footerOffset = $('.layout-product').height() - windowHeight;
		});

		// Stick sidebar
      	var productSummaryOffset = 100;
      
      	if ( $body.hasClass('has-site-notice')) {
      		productSummaryOffset = 130;	
        }
      	
      	if ($(window).width() > 768) {
          $(".product-summary-inner").stick_in_parent({
              offset_top  : 100,
              parent : '.layout-product'
          });
      	}

      	// Simple add to cart
      	if ($('.product-form').hasClass('simple')) {
          
      		// Finished, show the mini cart
          	$('.button-add-to-cart').on('click', function(e) {
				e.preventDefault();	
              
				// Add to basket
          		CartJS.addItem($(this).data('id'), 1);    
              
              	// Show minicart
               	modalCart.show();
          	});
          
        } else if ($('.product-form').hasClass('single-variable')) {
          	// Variation add to cart
          
      		// Map swatches to variation
          	$('.swatch').on('click', function(e) {
              	$('.product-variations option:contains("' + $(this).data('value') + '")').attr('selected', 'selected');
            });
          
          	// Update selector from hash
          	if (window.location.hash) {
                swatch = window.location.hash.replace('#','');
                $('.swatch').each(function(e) {
                  if ($(this).data('value').split(' ').join('').replace('-','').toLowerCase() == swatch) {
                    
                    var $target = $(this);
                    
                    setTimeout(function(){ 
                    	$target.trigger('click');
                    }, 1000);
                  }
                });
            }
          
      		// Finished, show the mini cart
          	$('.button-add-to-cart').on('click', function(e) {

				e.preventDefault();
                
                let properties = {};
              
                // Does the product have a monogram
                if ( productMonogram.length ) {

                  if ( productMonogram.val() == 0 ) {
                    alert('Please enter your monogram.');
                    return false;
                  }
                  
                  properties = {
                    "Monogram" : productMonogram.val()
                  };
                }

                // Get product ID
                if ( $('.bundle.active').length ) {
                  // Get product variation
                  id = $('.bundle.active .product-variation-select').val();
                } else {
                  id = $('.product-variations').val();
                }

                // Get Quantity
                if ( $('.bundle.active .product-bundle-quantity').length ) {
                    quantity = $('.bundle.active .product-bundle-quantity').val();
                } else {
                    quantity = 1;
                }
                      
				// Add to basket
          		CartJS.addItem(id, quantity, properties);    
                
              	// Show minicart
               	modalCart.show();
          	});          
        }      
      
      	// Accordion
      	var $accordions = $(".product-accordion li:not('.product-accordion-modal')");
      	var $accordionTitles = $(".accordion-title:not('.accordion-exclude')");
      	
      	$accordionTitles.on('click',function(e) {
      		e.preventDefault();
        	
          	if ($(this).parent().hasClass('active')) {
            	$accordions.removeClass('active');
            } else {
            	$accordions.removeClass('active');
				$(this).parent().addClass('active');            
            }
          
          	// Update sticky sidebar
          	$(document.body).trigger('sticky_kit:recalc');

        });

        // Quantity
  		$('.quantity-container button').on('click', function(e) {
          e.preventDefault();

          $quantity = $(this).parent().find('input');
          quantity = parseInt($quantity.val());	
          max = parseInt($quantity.attr('max'));      	
          
          if ($(this).hasClass('quantity-minus')) {
              // Decrement
              if (quantity >= 1) {
                  $quantity.val(quantity-1).trigger('change');
              }
          } else {
              // Increment
              // Do we have a variation selected
           	  if (!$(this).parent().parent().find('select').val()) {
              	alert('Please select a size');
              } else {
                
                
                if (max <= quantity) {
                	// No more stock
                  	alert('That is currently all we have in stock. Please get in touch if you need more.');
                } else {
                  	$quantity.val(quantity+1).trigger('change');
                }
              }
          }

    	});
      
      
        // Recently Viewed
		productRecentlyViewed();  
     
      	// Product Gallery
      	productGallery();
      
      	// Sizing Chart
      	productSizingChart();
    }
  	
  	function init_account() {
    	
      	// Check for password reset anchor in URL
      	if(window.location.hash) {
      		var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
			
          	if (hash == 'recover') {
          		$body.addClass('show-account-recovery');
            }
  		}
    }
  
  	function init_cookie() {
    	var consent = localStorage.getItem('cookie_consent');
      
      	if (!consent) {
      		var $cookieBanner = $('.layout-cookie-banner');
          	var $cookieBannerButton = $('.button-cookie-accept')
          
          	$cookieBanner.addClass('active');
          	
          	$cookieBannerButton.on('click', function(e) {
          		localStorage.setItem('cookie_consent', true);
              	$cookieBanner.removeClass('active');
            });
        }
  	}
  
  	function init_page() {
      	// FAQs
      	if ($('.faq').length) {
          var $faqs = $('.faq');
          var $faqQuestion = $('.faq-question');

          $faqQuestion.on('click',function(e) {
              e.preventDefault();

              if ($(this).parent().hasClass('active')) {
                  $faqs.removeClass('active');
              } else {
                  $faqs.removeClass('active');
                  $(this).parent().addClass('active');            
              }
          });
        }
      
      	// Size Chart
      	if ($('.page-sizing-chart').length) {
          	productSizingChart();
        }
    }
  
  	// Account
  	function init_account() {
      
    	// Edit Address
      	$addressContainer = $('.account-add-edit-container')
      	$addressEditButton = $('.address-edit');
      	$addressEdit = $('.account-edit-address');
      	
      	$addressEditButton.on('click', function(e) {
          	e.preventDefault();
      		$addressEdit.empty().html($(this).next().clone());
        	$addressContainer.addClass('is-editing');
          
          	$([document.documentElement, document.body]).animate({
            	scrollTop: $addressContainer.offset().top
          	}, 300);
        });
      
      	// Edit Address : Cancel
      	$('body').on('click', '.address-edit-toggle', function(e) {
          	e.preventDefault();
         	$addressContainer.removeClass('is-editing');
        });
      
      	// Delete Address
      	$('.address-delete-form').on('submit', function(e) {
        	const confirmMessage = event.target.getAttribute('data-confirm-message');

        	if (!window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        	    event.preventDefault();
        	}
        });
  	}
  
  	// Product Update inventory
  	function productUpdateInventory(colour) {
      	$('.product-variation-select option').each(function() {
      		
         	size = $(this).val();
          	variation = colour + ' / ' + size;
         	         
            for (var i = 0; i < variations.length; i++) {
                if (variations[i]['title'] == variation) {
                  if (!variations[i]['available']) {
                  	// Variation not available, disable
                    $(this).attr('disabled','disabled');
                  } else {
                    $(this).removeAttr('disabled');
                  }
                }
            }
          	
        });
    }
 
	// Product Recently Viewed
	function productRecentlyViewed() {
		
		// Recently Viewed
		// recently_viewed is global with current item
		var viewed = localStorage.getItem('baea_recently_viewed');
		var current_product = recently_viewed;
		var already_viewed = false;
		var $recentlyViewed = $('.layout-recently-viewed');
      	var $recentlyViewedGrid = $('.layout-recently-viewed .grid');
		var output = '';
      	var loaded = 0;
		
      
		if (!viewed) {
			viewed = [];
		} else {
			viewed = JSON.parse(viewed);
			viewed.reverse();
		}
		
		// Trim to 3 Products
		if (viewed.length > 3) {
			viewed = viewed.slice(0,3);
		}
      
		// Add this product as viewed
      	if (viewed.indexOf(current_product) == -1) {
      		viewed.push(current_product);
          	// Save to local storage
			localStorage.setItem('baea_recently_viewed', JSON.stringify(viewed));
        }
		
		// Build HTML
      	for (let i = 0; i < viewed.length; i++) {
          	
            $.ajax({
              url: 'https://baea.com/products/' + viewed[i] + '.js',
              success: function(data) {
                	
                	price = '';
                	if ( data.price_min < data.price_max) {
                		price = '<h3 class="product-tease-price f-13">' + Shopify.formatMoney(data.price_min) + ' ' + Shopify.formatMoney(data.price_max) + ' ' + Shopify.currency.active + '</h3>';
                    } else if (data.price > 0) {
                      	price = '<h3 class="product-tease-price f-13">' + Shopify.formatMoney(data.price) + ' ' + Shopify.currency.active + '</h3>';
                    }
                
              		output = output + '<li><a href="'+ data.url +'" class="tease product"><div class="product-image image" style="padding-top:108.579465541490858%"><img data-src="' + data.featured_image +'" width="711" height="772" alt="' + data.title +'" class="lazyload"></div><div class="product-caption"><h2 class="product-tease-title f-13">' + data.title +'</h2>' + price + '</div></a></li>';
              		loaded++;
                
                	if (loaded == (viewed.length-1)) {
                		productRecentlyViewedHtml();
                    }
              },
              dataType: 'json'
            });
      	};
      
      	function productRecentlyViewedHtml() {
			      
          // Add HTML to the page
          if (output) {
              $recentlyViewed.removeClass('visually-hidden');
              $recentlyViewedGrid.append(output);

              // Update LazyLoad
              if (lazyLoadImages) {
                  lazyLoadImages.update();
              }
          }		
        }
	}	
  	
  	function productGallery() {
  		      		
      	if ($window.width() <= 768 ) {
      		
          	// Make gallery a slideshow
          	if ($('.gallery-set').length) {
              $('.gallery-set').each(function(e) {	
              	$(this).slick({		  
                      infinite	: false,	
                      dots		: true,	
                      arrows	: false,
                      responsive: [{
                              breakpoint: 4000,
                              settings: "unslick" 
                          }, 
                          {
                              breakpoint: 769,
                              settings: {
                                  slidesToShow: 1,
                                  infinite: false,
                              }
                          }
                      ]
            	});	
              });
            }
        }    
     
    }


  
  	// Product : Sizing Chart
  	function productSizingChart() {
  		
    	var $sizingChartLinks = $('.sizing-chart-links a');
      	var $sizingChartSections = $('.sizing-chart-sizes');
      	var $sizingChartUnits = $('.sizing-chart-units a');
      	var units = 'cm';
      	var section = 'duvet-covers';

      
      	// Modal : Sizing
      	if ($('#modal-sizing').length) {
      		const modalSizingElement = document.getElementById('modal-sizing');
	 		const modalSizing = new A11yDialog(modalSizingElement);		 
        }
   
      
        // Sizing : Change Units
        $sizingChartUnits.on('click', function(e) {
          e.preventDefault();
          
          $sizingChartUnits.removeClass('active');
          $(this).addClass('active');

          units = $(this).data('unit');

          // Show sizes
          $sizingChartSections.removeClass('active');
          $('#' + section + '-' + units).addClass('active');
        });

        // Sizing : Change Sizes
        $sizingChartLinks.on('click', function(e) {
          e.preventDefault();
          
          $sizingChartLinks.removeClass('active');
          $(this).addClass('active');

          section = $(this).data('section');

          // Show sizes
          $sizingChartSections.removeClass('active');
          $('#' + section + '-' + units).addClass('active');       
        });
      
    }
  
  	function init_cart() {
  		
    	// Update quantity on change
      	$('.cart-quantity input').on('change', function(e) {
      		CartJS.updateItemById($(this).data('id'), $(this).val());
        });
      
    }
  
 	function init_category() {
      	
      	// Custom titles from URL parameters
      	category_custom_title();
      
      	// Build colour filters
      	var path = $('.filter').data('path').substring(0, $('.filter').data('path').lastIndexOf("/"));
		var $products = $('.layout-products li');
      	var colours = [];
      	var filterHtml = '';
      	var $filterColourContainer = $('.filter .dropdown-options');
      
     	$products.each(function(e) {
          	if ($(this).data('colour')) {
        		colours.push($(this).data('colour'));
            }
        });
      
      	// Make the colour array unique
      	colours = colours.filter(function (e, i, colours) {
    		return colours.lastIndexOf(e) === i;
        });
      
      	// Build filter HTML
      	for (i = 0; i < colours.length; i++) {
			filterHtml = filterHtml + '<li><a href="#" data-colour="' + colours[i] + '" class="filter-swatch"><div class="swatch"><img src="'+ path +'/swatch_' + colours[i] + '.jpg" width="20" height="20" alt="' + colours[i] +'"></div>'+ colours[i] + '</a></li>';
        }
      	$filterColourContainer.html(filterHtml);
      	
    

            
		// List.js
		var options = {
		  valueNames: [
            { data: ['price-high'] },
            { data: ['price-low'] },
            { data: ['date'] },
            { data: ['campaign']  },
            { data: ['sort']  },
            { data: ['colour']  },
          ]
		};
		
		var list = new List('sortable', options);
		var $sort = $('.sort .dropdown-option');
		var $sortLabel = $('.sort-label');
        var campaignImagesVisible = true;
            
		// Sort
		$sort.on('click', function(e) {
			e.preventDefault();
			
			if ($(this).hasClass('active')) {
				$sort.removeClass('active');
				$sortLabel.text('Featured');	
            		
            	// Sort List
            	list.sort($(this).data('sort'), { order: 'asc' });

            
			} else {
				$sort.removeClass('active');
				$(this).addClass('active');
				$sortLabel.text($(this).text());
				
            	// Sort List
            	list.sort($(this).data('value'), { order: $(this).data('order') });
				
                // Remove Campaign images from sorting
                if (campaignImagesVisible) {
                    list.remove('campaign', 1);
                    campaignImagesVisible = false;
                }	            
            }
		});  
            
        // Filter : Colour 
        $filterSwatches = $('.filter-swatch');
        
        $filterSwatches.on('click', function(e) {
            	
           	e.preventDefault();
            
            if ($(this).hasClass('active')) {
            		
           		// Clear CSS class
            	$filterSwatches.removeClass('active');
            
            	// Clear filter
            	list.filter();
            } else {
            	
            	// Add CSS class
            	$filterSwatches.removeClass('active');
            	$(this).addClass('active');
            
            	// Apply filter
            	colour = $(this).data('colour');
            
                list.filter(function(item) {
            	            
                    if (item.values().colour == colour) {
                        return true;
                    } else {
                        return false;	
                    }
                });
            }
        });
    }
  
    function category_custom_title() {
    	const queryString = window.location.search;

      	if (queryString) {
        	const parameters = new URLSearchParams(queryString);
          	var hero_title = parameters.get('title');
            hero_title = sanitize(hero_title);
            
            if (hero_title) {
				document.querySelectorAll('.collection-hero-title')[0].textContent = hero_title;
        	}
        }
    }

    function sanitize(string) {
      const map = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#x27;',
          "/": '&#x2F;',
      };
      const reg = /[&<>"'/]/ig;
      return string.replace(reg, (match)=>(map[match]));
    }
  
  	init_general();
  	init_layouts();
});
